module.exports = __webpack_public_path__ + "static/media/fr_medical_id_booklet@2x.e22226b4.png";